import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchHolidays } from "../redux/slices/absenceSlice";
import { fetchUsers } from "../redux/slices/userSlice";

import { formatUsers, formatHolidays } from "../utils/helpers";

export const useDesktopHomeData = () => {
  const dispatch = useDispatch();
  
  const [apiHolidays, setApiHolidays] = useState([]);

  const users = useSelector((state) => state.users.items || []);
  const currentUser = useSelector((state) => state.users.currentUser);

  const isHR = currentUser?.role === "HR" || currentUser?.is_admin === true;

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchHolidays(new Date().getFullYear()))
      .unwrap()
      .then(setApiHolidays)
      .catch((err) => console.error("Erro ao buscar feriados:", err));
  }, [dispatch]);

  const realMembers = useMemo(() => formatUsers(users), [users]);
  const upcomingHolidays = useMemo(() => formatHolidays(apiHolidays), [apiHolidays]);

  return {
    isHR,
    realMembers,
    upcomingHolidays,
  };
};